import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-container-stack',
  styleUrl: 'container-stack.css',
  shadow: true,
})
export class ContainerStack {
  @Prop() maxWidth: number = 1024;
  @Prop() paddingTop: number = 0;
  @Prop() paddingBottom: number = this.paddingTop;

  render() {
    return (
      <Host style={{
        maxWidth: `${this.maxWidth}px`,
        paddingTop: `${this.paddingTop}px`,
        paddingBottom: `${this.paddingBottom}px`
      }}>
        <slot></slot>
      </Host>
    );
  }

}
